<template>
    <el-row class="lnk-pagination-v">
		<link-pagebar
			:size-option="pageSizes"
			:page="page"
			:page-size="rows"
			:total-size="totalNum"
			:show-page-num="showPageNum"
			@sizeChange="handleSizeChange"
			@jumpPage="handleCurrentChange"
			@prevPage="handleCurrentChange"
			@nextPage="handleCurrentChange"
		/>

        <span class="pagination-right-text"
              @click="toggleTotalNum"
              v-html="$t('LnkPaginationV.labelRightHint',info)"></span>
    </el-row>
</template>

<script>
import {typeOf} from '@utils/linktools';
import {debounce} from 'throttle-debounce'

export default {
    name: 'lnk-pagination-v',
    data: function(){
        return{
            totalNum: 0,
            info: {
                startRow: 0,
                endRow: 0,
                totalHint: 0
            }
        };
    },

    props: {
        page: {
            type: Number,
            required: true
        },
        rows: {
            type: Number,
            required: true
        },
        total: Number,
        totalFlag: {
            type: Boolean,
            default: false
        },
        pageSizes: {
            type: Array,
            default: () => [10, 20, 30, 40, 50, 100]
        },
		showPageNum: {type: Boolean,default: true},
        data: Array
    },
    watch: {
		freshKey(){
			this.freshInfo();
		}
    },
	computed: {
    	freshKey(){
    		return `${this.page}-${this.rows}-${this.total}-${this.totalFlag}-${this.data.length}`
		}
	},
    methods: {
        /**
         * 每页行数发生变化
         * @param val
         */
        handleSizeChange: function(val){
            this.$emit('size-change', val);
        },
        /**
         * @method：getStartRow
         * @createdBy:HuangJian
         * @date:2019/3/28
         * @params：
         * @description：获取开始行索引
         */
        getStartRow(total){
            var result = 0;
            if(this.page >0 && total>0){
                result = (this.page -1) * this.rows +1;
            }
            if(result > total){
                result = (Math.ceil(total / this.rows) - 1) * this.rows + 1;
            }
            return result;
        },
        /**
         * @method：getEndRow
         * @createdBy:HuangJian
         * @date:2019/3/28
         * @params：
         * @description：获取结束行索引
         */
        getEndRow(total){
            var result = 0;
            const endIndex = this.page * this.rows;
            if(total>0){
                result = total < endIndex ? total : endIndex;
                if(this.startRow > result){
                    this.$emit('empty-page', Math.ceil(result / this.rows)); // 向上取整，防止计算多次导致大量查询
                }
            }
            return result;
        },
        /**
         * @method：getTotal
         * @createdBy:HuangJian
         * @date:2019/3/28
         * @params：
         * @description：获取总数及提示数目
         */
        getTotal(){
            let total = 0;
            let totalHint = 0;
            const endIndex = this.page * this.rows;
            if(typeOf(this.total)==='number' && !isNaN(this.total)){
                total = this.total;
                if(endIndex >= this.total || this.totalFlag || this.total > endIndex +1){
                    totalHint = total;
                }else{
                    totalHint = total - 1 + '+';
                }
            }else if(Array.isArray(this.data)){
                total = endIndex - this.rows + this.data.length;
                if(this.data.length === this.rows){
                    totalHint = total + '+';
                    total++;
                }else{
                    totalHint = total;
                }
            }
            return {total, totalHint};
        },
        /**
         * @method：freshInfo
         * @createdBy:HuangJian
         * @date:2019/3/28
         * @params：count 用于统计mvg左侧向右侧移动的数据
         * @description：刷新显示信息
         */
        freshInfo(count = 0){
            let {total, totalHint} = this.getTotal();
            const startRow = this.getStartRow(total);
            const endRow = this.getEndRow(total);
            this.totalNum = total;
            this.$nextTick(() => {
            	if (count) {
            		totalHint = total + count;
					this.info = {totalHint, startRow, endRow};
				} else this.info = {totalHint, startRow, endRow};
            });
        },


        /**
         * 页数发生变化
         * @param val
         */
        handleCurrentChange: function(val){
            this.$emit('current-change', val);
        },
        /**
         * @method：toggleTotalNum
         * @createdBy:HuangJian
         * @date:2018/12/17
         * @params：
         * @description：触发请求总数事件
         */
        toggleTotalNum(e){
            const originEL = e.path[0] || {};
            if(!originEL || [].indexOf.call(originEL.classList,'total-num')<0) return;
            this.$emit('request-total');
        }
    },
	created(){
    	this.freshInfo = debounce(50, this.freshInfo).bind(this);
	},
	mounted() {
    	this.freshInfo();
	}
};
</script>

<style lang="scss">
	@include themeify{
		.lnk-pagination-v{
			.pagination-right-text{
				position: absolute;
				right: 0;
				top:0;
				font-size:12px;
				line-height: 28px;
				color:#868BA1;
				font-weight:normal;
				.total-num{
					color: pl-var(color-primary);
					text-decoration: none;
				}
			}
		}
	}

</style>
